export const validation_failed_border_color = "#F13467";
export const validation_succcess_border_color = "#d5d5d5";
